import { type PropsWithChildren, useId } from "react";
import classes from "./header.module.css";

export type LabelProps = PropsWithChildren<{
	icon: string;
}>;

export function Label(props: LabelProps) {
	const id = useId();
	return (
		<>
			<img className={classes.icon} aria-labelledby={id} src={props.icon} />
			<span className={classes.text} id={id}>
				{props.children}
			</span>
		</>
	);
}
